import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
  MDS_HEATWAVE_STOP_POLL_DELAY,
  MDS_HEATWAVE_STOP_POLL_INTERVAL,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface MysqlStopHeatWaveProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const MysqlStopHeatWave = (
  { location, databaseId, onExecute }: MysqlStopHeatWaveProps,
): JSX.Element => {
  const { invokeCall: invokeStop } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).mdsDatabaseApi.stopHeatWaveCluster },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resourceGroupName = decodeURIComponent(resourceGroup || "");
    const dbSystemName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.stopHeatWaveCluster(),
          message: Messages.notifications.inProgress.messages.stopHeatWaveCluster(dbSystemName),
        },
        success: {
          title: Messages.notifications.success.titles.stopHeatWaveCluster(),
          message: Messages.notifications.success.messages.stopHeatWaveCluster(dbSystemName),
        },
        failure: {
          title: Messages.notifications.failure.titles.stop(),
          message: Messages.notifications.failure.messages.stopHeatWaveCluster(dbSystemName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.MDS_HEATWAVE_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName,
            dbSystemName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.MDS_HEATWAVE_STOPPED_CHECK,
          delay: MDS_HEATWAVE_STOP_POLL_DELAY,
          interval: MDS_HEATWAVE_STOP_POLL_INTERVAL,
        },
      },
    };
    invokeStop({
      subscriptionId,
      resourceGroupName,
      dbSystemName,
    }, invokeOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newMysqlStopHeatWave = (
  props: MysqlStopHeatWaveProps,
): JSX.Element => (<MysqlStopHeatWave {...props} />);
